<template>
	<span class="button-inner">
		<IconSvg
				v-if="iconLeft"
				:icon="iconLeft"
		/>
		<span
				v-if="text"
				:class="{'sr-only' : hideText}"
				class="text"
		>
			{{ text }}
		</span>
		<IconSvg
				v-if="iconRight"
				:icon="iconRight"
		/>
	</span>
</template>
<script lang="ts" setup>
	import type {PropType} from 'vue';
	import IconSvg from '~/components/generic/IconSvg.vue';
	import type {AvailableIcon} from '~/lib/types/IconTypes';

	defineProps({
		text: {
			type: String,
			required: true
		},
		iconLeft: {
			type: String as PropType<AvailableIcon>,
			required: false,
			default: null
		},
		iconRight: {
			type: String as PropType<AvailableIcon>,
			required: false,
			default: null
		},
		hideText: {
			type: Boolean,
			default: false
		}
	});
</script>

<style scoped>
	.button-inner {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1rem;
	}

	.button-inner > :deep(*) {
		flex: 0 0 auto;
	}

	.button-inner > :deep(span, .icon) {
		display: block;
	}

	.text {
		text-decoration: none;
		max-width: 100%;
		overflow-wrap: break-word;
	}

	:deep(svg) {
		--icon-size: 20px;
	}
</style>
